import * as React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

const Star = createSvgIcon(
  <path d="M12,0l4.2,7.4L24,8.6L18.5,15l1.5,9l-8-5.1L4,24l1.5-9L0,8.6l7.8-1.2L12,0z M12,4.5l-2.8,5l-4.8,0.7l3.5,4.1L7,19.4l5-3.1l5,3.1l-0.9-5.1l3.5-4.1l-4.8-0.7C14.8,9.5,12,4.5,12,4.5z" />,
  'Star'
);

export { Star };
